import React from "react";
import styled from "@emotion/styled";
import DropdownsList from "./DropdownsList";
import FiltersTitle from "./FiltersTitle";

const Filters = () => {
	return (
		<Container>
			<FiltersTitle />
			<FiltersContainer>
				<DropdownsList />
			</FiltersContainer>
		</Container>
	);
};

export default Filters;

const Container = styled.div`
	margin-bottom: 6rem;
`;

const FiltersContainer = styled.div`
`;